module.exports = __webpack_public_path__ + "1d0ad2457d63afb6f4d1d3603fd11db7.png";